import React, { useState  } from 'react'
import "./navbar.scss";

const Navbar = (props) => {
  const goHome = () => {
    props.history.push('/dashboard')
  }
  const openQuickLink = (url) => {
    window.open(url, '_blank')
  }
  // const goToAmbiguity = () =>{
  //   props.history.push('/dashboard/ambiguity')
  // }
  return (
    <nav className="navBg">
      <ul>
      <li>
          {/*<a className="active">
            <i onClick={goHome} className="dashboard-icn" title="Homepage"></i>
            <span>Dashboard</span> aria-label="Homepage"
          </a>*/}
          {<button type="button" className="active" onClick={goHome} >
            <i className="dashboard-icn" aria-hidden="true" title="Homepage"></i>
            {/*<span>Dashboard</span>*/}
          </button>}
        </li>
        <li>{/* https://forms.office.com/Pages/ResponsePage.aspx?id=LXJ9toqqd0ehaevremo7Zwp_KoqUJAVOlWEWUsl3RzlURDJaVkRIVlhQRTdTRFkxSVJTQ05OVDlMViQlQCN0PWcu */}
        {/* <a>
            <i onClick={()=>openQuickLink('https://thermofisher.sharepoint.com/sites/VOICECXPlatform/_layouts/15/listforms.aspx?cid=NmQ3YzAwYTctMDdlYS00NzMyLWJlZjUtZWJmMmEwM2U0Zjkx&ct=1741286368598&or=Teams-HL&nav=NDdmMGM1NWUtMGRjYi00OWYyLTlmYmMtNDhlODllZGYxYzBl')} title="Report an issue or submit feedback" className="feedback-icn"></i>
            <span>Submit Feedback</span>
          </a>*/}  
          {<button type="button" onClick={()=>openQuickLink('https://thermofisher.sharepoint.com/sites/VOICECXPlatform/_layouts/15/listforms.aspx?cid=NmQ3YzAwYTctMDdlYS00NzMyLWJlZjUtZWJmMmEwM2U0Zjkx&ct=1741286368598&or=Teams-HL&nav=NDdmMGM1NWUtMGRjYi00OWYyLTlmYmMtNDhlODllZGYxYzBl')}>
            <i className="feedback-icn" aria-hidden="true" title="Report an issue or submit feedback"></i>
          </button>}
        </li>
        <li>
          {/*<a>
            <i onClick={()=>openQuickLink('https://thermofisher.sharepoint.com/sites/VOICECXPlatform/SitePages/Home.aspx')} title="VOICE Info & FAQs" className="info-icn"></i>
            <span>VOICE Info and FAQs</span>
          </a>*/}
            {<button type="button" onClick={()=>openQuickLink('https://thermofisher.sharepoint.com/sites/VOICECXPlatform/SitePages/Home.aspx')}>
            <i aria-hidden="true"  title="VOICE Info & FAQs" className="info-icn"></i>
            </button>}
        </li>
        {<li>
          {/*<a>
            <i onClick={()=>openQuickLink('https://geneai.thermofisher.com/ask-our-docs/dpe_geneai_index_VOICE_Platform_Coach')} title="Access Gene.AI Ask-Our-Docs VOICE Platform Coach for support and information." className="gene-icn"></i>
            <span>Access Gene.AI Ask-Our-Docs VOICE Platform Coach for support and information.</span>
          </a>*/}
           <button type="button" onClick={()=>openQuickLink('https://geneai.thermofisher.com/ask-our-docs/dpe_geneai_index_VOICE_Platform_Coach')} >
            <i aria-hidden="true" title="Access Gene.AI Ask-Our-Docs VOICE Platform Coach for support and information." className="gene-icn"></i>
          </button>
        </li>}
        {/* <li>
          <a>
            <i onClick={goToAmbiguity} title="Ambiguity" className="ambi-icn"></i>
            <span>Ambiguity</span>
          </a>
        </li> */}
        {/* <li>
          <a>
            <i className="view-icn"></i>
            <span>CCO View</span>
          </a>
        </li>
        <li>
          <a>
            <i className="summary-icn"></i>
            <span>CX Summary</span>
          </a>
        </li>
        <li>
          <a>
            <i className="revenue-icn"></i>
            <span>Revenue/P&amp;L</span>
          </a>
        </li>
        <li>
          <a>
            <i className="account-icn"></i>
            <span>Account Hierarchies</span>
          </a>
        </li> */}
      </ul>
    </nav>
  );
};

export default Navbar;
